<template>
    <div>
        <el-form :model="model" status-icon label-width="140px" label-position="top">
            <el-form-item :error="error_form.message">
                <el-input type="textarea" v-model="model.message" :autosize="{ minRows: 4, maxRows: 10 }" :placeholder="$t('request_access_offer_placeholder')"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="toRequest" :loading="loading_form">{{ $t('request_access_offer_button') }}</el-button>
                <el-button @click="cancel">{{ $t('cancel') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "RequestAccessOffer",
        props: ['offer'],
        data () {
            return {
                model: {},
                error_form: {},
                loading_form: false,
            }
        },
        methods: {
            toRequest () {
                this.loading_form=true;
                this.$axios.post('/tickets', {
                    section_id: 1,
                    message: this.model.message,
                    topic: this.$t('connection_offer', this.offer),
                    offer_id: this.offer.id
                }).then(() => {
                    this.error_form = {};
                    this.loading_form = false;
                    this.cancel();
                    this.$message.success(this.$t('notice.request_access_offer_success'));
                    this.$emit('update')

                }).catch((error) => {
                    if (error.response.status === 422) {
                        this.error_form = error.response.data;
                    }

                    this.loading_form=false;
                });
            },
            cancel () {
                this.$emit('cancel')
            }
        }
    }
</script>

<style scoped>

</style>